import { CruiseModel, useGetCruise } from 'api-hooks/cruise';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import CreateSelectComponent from 'components/elements/create-select-component';
import { camelizeKeys } from 'humps';
import { useRouter } from 'next/router';
import React from 'react';

import useNavigation from './use-navigation';

export default function useGetCruiseRoom({ cruiseId }) {
  const [options, setOptions] = React.useState<Option[]>([]);
  const { navigate } = useNavigation();
  const { asPath } = useRouter();

  const onClickCreate = React.useCallback(() => {
    PreviousNavigation.set(asPath);
    navigate(NavigationRoutes.CruisesView, { id: cruiseId, editable: true });
  }, [asPath, cruiseId, navigate]);

  const { isFetching } = useGetCruise(
    {
      id: cruiseId,
    },
    {
      enabled: !!cruiseId,
      onSuccess: (data) => {
        if (data.data) {
          const result: CruiseModel = camelizeKeys(data.data) as CruiseModel;
          setOptions(
            result.cruiseRooms
              .map((item) => ({
                id: item.id,
                label: `${item.type} (${item.size})`,
                disabled: false,
              }))
              .concat([
                {
                  id: 'action_create',
                  label: (
                    <div
                      style={{
                        padding: '8px 16px',
                      }}
                      key="action_create"
                    >
                      <CreateSelectComponent
                        onCreate={onClickCreate}
                        label="Create New"
                      />
                    </div>
                  ) as unknown as string,
                  disabled: true,
                },
              ]),
          );
        }
      },
    },
  );

  return {
    options,
    setOptions,
    isFetching,
  };
}
